import * as React from 'react';
import Box from '@mui/material/Box';
import PhotographersList from '../components/PhotographersList/PhotographerList';
import TimelineCalendar from '../components/TimelineCalendar/TimelineCalendar';
import ScrollButtons from '../components/ScrollButtons';
import { Order, Photographer } from '../BookingsCalendarTypes';
import { useCalendarContainerWidth } from '../state/useCalendarContainerWidth';
import ICalendarItem from '../../../calendar/Types';

type CalendarBodyProps = {
    isAdvancedMode: boolean;
    photographers: Photographer[];
    onChangeBookingInfo: (newBookingInfo: Partial<ICalendarItem> | null) => void;
    selectedOrder: Order;
    selectedBookingDate: Date;
    bookingInfo: Partial<ICalendarItem>;
    onChangePhotographer: (newPhotographer: Photographer) => void;
    hideTravelTimes: boolean;
};

function CalendarBody({
    isAdvancedMode,
    photographers,
    selectedOrder,
    selectedBookingDate,
    onChangeBookingInfo,
    bookingInfo,
    onChangePhotographer,
    hideTravelTimes
}: CalendarBodyProps) {
    let containerRef = React.useRef<HTMLDivElement | null>(null);
    let scrollRef = React.useRef<HTMLElement>();
    let containerSizeAndPosition = useCalendarContainerWidth(containerRef, [true, photographers]);
    const [activeRow, setActiveRow] = React.useState<number | null>(null);

    const handleActiveRow = (rowIndex: number) => {
        setActiveRow(rowIndex);
    };

    return (
        <Box
            ref={containerRef}
            sx={{
                display: 'flex',
                marginTop: !isAdvancedMode ? '20px' : '5px'
            }}
        >
            <PhotographersList
                photographers={photographers}
                selectedOrder={selectedOrder}
                firstPhotographerId={bookingInfo && bookingInfo.userId}
                activeRow={activeRow}
            />
            <Box
                aria-label="timeline-calendar"
                ref={scrollRef}
                id={'time-grid'}
                sx={{
                    display: 'grid',
                    overflowX: 'hidden',
                    maxWidth: '100%',
                    height: '100%'
                }}
            >
                <TimelineCalendar
                    ref={scrollRef}
                    containerSizeAndPosition={containerSizeAndPosition}
                    photographers={photographers}
                    selectedOrder={selectedOrder}
                    selectedDate={selectedBookingDate}
                    onChangeBookingInfo={(newBookingInfo) => onChangeBookingInfo(newBookingInfo)}
                    bookingInfo={bookingInfo}
                    onChangePhotographer={onChangePhotographer}
                    isAdvancedMode={isAdvancedMode}
                    hideTravelTimes={hideTravelTimes}
                    activeRow={activeRow}
                    onActiveRow={handleActiveRow}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: !isAdvancedMode ? '133px' : '175px',
                        right: '0'
                    }}
                >
                    <ScrollButtons ref={scrollRef} />
                </Box>
            </Box>
        </Box>
    );
}

export default CalendarBody;
